//--------------------------------------------------------------------//
//******************** AgentToolsService ******************************//
//--------------------------------------------------------------------//
// API communication layer for an agent's tool allowlist (system tools
// plus MCP tools fetched live from the agent's GudHub MCP connector).
import { request } from '../agents.request.js';

angular.module('agentsTableModule')

    .service('AgentToolsService', [function () {
        // Fetches the full tool catalog available to this agent, grouped by
        // catalog (system/editor/admin today), each entry tagged with its
        // current enabled state.
        this.getTools = function (agentId) {
            return request(`/agents/${encodeURIComponent(agentId)}/tools`, {}, 'GET');
        };

        // Enables a single tool, leaving the rest of the group's allowlist untouched.
        // group is 'system' or 'mcp' (mcp covers both the editor and admin catalogs).
        this.enableTool = function (agentId, group, toolName) {
            return request(`/agents/${encodeURIComponent(agentId)}/tools/${encodeURIComponent(group)}/${encodeURIComponent(toolName)}`);
        };

        // Disables a single tool, leaving the rest of the group's allowlist untouched.
        this.disableTool = function (agentId, group, toolName) {
            return request(`/agents/${encodeURIComponent(agentId)}/tools/${encodeURIComponent(group)}/${encodeURIComponent(toolName)}/delete`);
        };

        // Fetches one tool's full definition, including its complete input_schema
        // (the catalog endpoint above strips schemas down to name/description/enabled).
        this.getToolSchema = function (agentId, toolName) {
            return request(`/agents/${encodeURIComponent(agentId)}/tools/${encodeURIComponent(toolName)}`, {}, 'GET');
        };
    }]);
